/**
 * Sélecteurs tolérants du profil courant : lisibles sur un store partiel
 * (tests, shell mobile), ils rendent `undefined` plutôt que de lever.
 */
import { consentementAJour, type Consentements } from '../../constants/legal';

interface EtatProfil {
  userProfile?: {
    currentProfile?: { userId?: string; displayName?: string; email?: string; consentements?: Partial<Consentements> } | null;
    invitationRequise?: boolean;
    status?: string;
  };
}

/** Identifiant de la personne connectée, ou `undefined` si le profil n'est pas chargé. */
export const selectUserIdCourant = (state: unknown): string | undefined =>
  (state as EtatProfil | undefined)?.userProfile?.currentProfile?.userId || undefined;

/** Nom affiché de la personne connectée, ou `undefined`. */
export const selectDisplayNameCourant = (state: unknown): string | undefined =>
  (state as EtatProfil | undefined)?.userProfile?.currentProfile?.displayName || undefined;

/** La porte d'invitation doit-elle remplacer le shell ? (13/10/2026 ; faux sur un store partiel) */
export const selectInvitationRequise = (state: unknown): boolean =>
  (state as EtatProfil | undefined)?.userProfile?.invitationRequise === true;

/**
 * La porte de consentement doit-elle remplacer le shell ? (C27 SP2) Vrai quand le
 * profil est chargé et ne porte pas la version courante des textes ; faux tant que
 * le profil n'est pas là (on ne sait pas encore) et sur un store partiel.
 */
export const selectConsentementRequis = (state: unknown): boolean => {
  const profil = (state as EtatProfil | undefined)?.userProfile?.currentProfile;
  return !!profil && !consentementAJour(profil.consentements);
};

/** Le profil n'a pas encore répondu (ni succès ni échec) : l'aiguillage attend avant de peindre un shell. */
export const selectProfilEnAttente = (state: unknown): boolean => {
  const up = (state as EtatProfil | undefined)?.userProfile;
  if (!up || up.currentProfile) return false;
  return up.status === undefined || up.status === 'idle' || up.status === 'loading';
};

/** Adresse e-mail du profil courant, pour la confirmation de la suppression du compte. */
export const selectEmailCourant = (state: unknown): string | undefined =>
  (state as EtatProfil | undefined)?.userProfile?.currentProfile?.email || undefined;

/** Statut de chargement de la tranche (`LOADING_STATES.*`), ou `undefined` sur un store partiel. */
export const selectStatutProfil = (state: unknown): string | undefined =>
  (state as EtatProfil | undefined)?.userProfile?.status;
